import { render, staticRenderFns } from "./CommercialDashboard.vue?vue&type=template&id=cb56fb20"
import script from "./CommercialDashboard.vue?vue&type=script&lang=js"
export * from "./CommercialDashboard.vue?vue&type=script&lang=js"
import style0 from "./CommercialDashboard.vue?vue&type=style&index=0&id=cb56fb20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports